@if (user) {
  <div class="row d-flex">
    <div class="col-lg-6 col-12 d-flex">
      <div class="card mb-5 mb-xl-10 flex-fill" id="kt_profile_details_view">
        <div class="card-header cursor-pointer align-items-center">
          <div class="card-title m-0">
            <h3 class="fw-bold m-0">Profile Details</h3>
          </div>
          <app-button
            [iconClass]="'fa fa-edit fs-2'"
            [variant]="'primary'"
            [size]="'md'"
            (clicked)="openEditProfileModal()"
          />
        </div>
        <div class="card-body p-9">
          <div class="row mb-7">
            <label class="col-lg-4 fw-semibold text-muted">Full Name</label>
            <div class="col-lg-8">
              <span class="fw-bold fs-6 text-gray-800">{{ user.first_name }} {{ user.last_name }}</span>
            </div>
          </div>
          <div class="row mb-7">
            <label class="col-lg-4 fw-semibold text-muted">Riding Club</label>
            <div class="col-lg-8 fv-row">
              @if (user.riding_club) {
                <span class="fw-semibold text-gray-800 fs-6">{{ user.riding_club }}</span>
              } @else {
                <span class="fw-semibold text-gray-800 fs-6">Not provided</span>
              }
            </div>
          </div>
          <div class="row mb-7">
            <label class="col-lg-4 fw-semibold text-muted">Email</label>
            <div class="col-lg-8">
              <a href="#" class="fw-semibold fs-6 text-gray-800 text-hover-primary">{{ user.email }}</a>
            </div>
          </div>
          <div class="row mb-7">
            <label class="col-lg-4 fw-semibold text-muted">Phone
              <span class="ms-1" data-bs-toggle="tooltip" title="Phone number must be active">
													<i class="ki-duotone ki-information fs-7">
														<span class="path1"></span>
														<span class="path2"></span>
														<span class="path3"></span>
													</i>
												</span></label>
            <div class="col-lg-8 d-flex align-items-center">
              @if (user.phone) {
                <span class="fs-6 text-gray-800 me-2">{{ user.phone }}</span>
              }
              @else {
                <span class="fw-bold fs-6 text-gray-800 me-2">Not Provided</span>
              }
            </div>
          </div>
          <div class="row mb-7">
            <label class="col-lg-4 fw-semibold text-muted">Date of birth</label>
            <div class="col-lg-8">
              @if (user.date_of_birth) {
                <a href="#" class="fw-semibold fs-6 text-gray-800 text-hover-primary">{{ formatTimeYMD(user.date_of_birth) }}</a>
              } @else {
                <a href="#" class="fw-semibold fs-6 text-gray-800 text-hover-primary">Not provided</a>
              }
            </div>
          </div>
          <div class="row mb-7">
            <label class="col-lg-4 fw-semibold text-muted">Address</label>
            <div class="col-lg-8">
              <a href="#" class="fw-semibold fs-6 text-gray-800 text-hover-primary">{{ user.address }}, {{user.zip_code}} {{user.city}}, {{user.country}}</a>
            </div>
          </div>
          <div class="row mb-7">
            <label class="col-lg-4 fw-semibold text-muted">Active</label>
            <div class="col-lg-8">
              @if (user.active == 1) {
                <span class="badge badge-success">Active</span>
              } @else {
                <span class="badge badge-dark">Inactive</span>
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
}
